import { Injectable } from '@angular/core';


@Injectable()
export class StorageService {

    constructor() {
      //why is this empty?
    }

    setExternalLinks(data: any) {
        localStorage.setItem('external_links', JSON.stringify({
            'learnAboutIoUrl': data.learnAboutIoUrl,
            'livingWithcancer': data.livingWithCancerUrl,
            'registryDashboardkLink': data.registryDashboardkLink
        }));
    }

    setBlogs(blogs: any) {
        localStorage.setItem('blogs', JSON.stringify(blogs));
    }

    setRegistryExperience(data: any) {
        localStorage.setItem('registry_experience', JSON.stringify(data));
    }

    setLoginEmail(data: any) {
        localStorage.setItem('email', JSON.stringify(data));
    }

    setIdHospital(data: any) {
        localStorage.setItem('idHospital', JSON.stringify(data));
    }

    setClinic(data: any) {
        localStorage.setItem('clinic', JSON.stringify(data));
    }

    setUsername(data: any) {
        localStorage.setItem('username', JSON.stringify(data));
        console.log(data);
    }

    setShowName(data: any){
        localStorage.setItem('showName', JSON.stringify(data));
        console.log(data);
    }

    setLanguageList(data: any){
        localStorage.setItem('languageList', JSON.stringify(data));
        console.log(data);
    }

    setChangedLanguage(data: any){
        localStorage.setItem('changedLanguage', JSON.stringify(data));
        console.log(data);
    }

    setClinicName(data: any) {
        localStorage.setItem('clinicName', JSON.stringify(data));
    }
}
